import React, { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FavoriteShowAction } from './FavoriteShowAction';
import { ActionSection, ImageShadow, Layout, Overlay } from './ImageOverlay.styles';
import { useA11yOverlayDelay } from './use-a11y-overlay-delay';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { useShowState } from '../../../providers/DataProvider/DataContext';
import { useDeviceState } from '../../../providers/DeviceProvider/DeviceContext';
import { getLabel, getLabelMap } from '../../InfoLabel/label-helper';
import { TeaserLabel } from '../../TeaserLabel/TeaserLabel';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShowImageOverlay = ({
  aspectRatio,
  isHovering,
  isFocused,
  show,
  labelOrder = [],
  hasHoverShadow = true,
  horizontalOnMobile = false,
  showFavoriteAction = true,
  showFavoriteUndo,
  showFavoriteSnackbar
}) => {
  const {
    t
  } = useTranslation();
  const {
    favoritesSupported,
    personalizationSupported
  } = useVideoConfig();
  const {
    favoriteShowIds
  } = useShowState();
  const {
    isTouchDevice
  } = useDeviceState();
  const isFavorite = favoriteShowIds.includes(show.id);
  const label = useMemo(() => getLabel(labelOrder, getLabelMap(t, undefined)), [labelOrder, t]);
  const {
    delayedIsHovered,
    delayedIsFocused
  } = useA11yOverlayDelay(isFocused, isHovering);
  const showFavorite = favoritesSupported && showFavoriteAction && (isTouchDevice || isFavorite || delayedIsFocused || delayedIsHovered);
  const showHoverSection = personalizationSupported && showFavorite;
  const showImageShadow = (isFocused || isHovering || isTouchDevice) && hasHoverShadow;
  const overlayVisible = label || showFavorite || showImageShadow;
  return /*#__PURE__*/_jsx(Fragment, {
    children: overlayVisible && /*#__PURE__*/_jsxs(Layout, {
      aspectRatio: aspectRatio,
      horizontalOnMobile: horizontalOnMobile,
      children: [showImageShadow && /*#__PURE__*/_jsx(ImageShadow, {}), /*#__PURE__*/_jsxs(Overlay, {
        children: [/*#__PURE__*/_jsx(TeaserLabel, {
          label: label
        }), showHoverSection && /*#__PURE__*/_jsx(ActionSection, {
          children: showFavorite && show && /*#__PURE__*/_jsx(FavoriteShowAction, {
            isHovering: isHovering,
            showId: show.id,
            showTitle: show.title,
            showFavoriteUndo: showFavoriteUndo,
            showFavoriteSnackbar: showFavoriteSnackbar,
            isFavorite: isFavorite
          })
        })]
      })]
    })
  });
};